import apiClient from '../components/apiClient';
import LetteringSequence from '../models/LetteringSequence';

export class LetteringService {
    static addLetteringSequence(letteringSequence: LetteringSequence) : Promise<LetteringSequence> {
        return apiClient.post<LetteringSequence>(`/Lettering/AddLetteringSequence`, letteringSequence).then(res => res.data);
    }

    static getLetteringSequencesByStyle(style: string) : Promise<LetteringSequence[]> {
        return apiClient.get<LetteringSequence[]>(`/Lettering/GetLetteringSequencesByStyle/${style}`).then(res => res.data);
    }

    static updateLetteringSequence(letteringSequence: LetteringSequence) : Promise<boolean> {
        return apiClient.put<boolean>(`/Lettering/UpdateLetteringSequence`, letteringSequence).then(res => res.data);
    }

    static deleteLetteringSequence(id: number, style: string) : Promise<boolean> {
        return apiClient.delete<boolean>(`/Lettering/DeleteLetteringSequence/${id}/${style}`).then(res => res.data);
    }
}